import Vue from 'vue'
import { mapActions } from 'vuex'

import App from './app.vue'
import store from './store/index'
import router from './router/index'

import ('./assets/less/app.less')

import components from './components/index.js'
import * as filters from './utils/filters'
Vue.use(components)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

window.wzWebApp = new Vue({
  router,
  store,
  el: '#webApp',
  render: h => h(App),
  computed: {},
  methods: {
    ...mapActions('account', ['loadAccount']),
    ...mapActions('timer', ['timerStart', 'timerStop']),
    ...mapActions("jianding", ["loadTabs","loadConfig"]),
    init() {
      this.loadAccount();
      this.timerStart({});
      this.loadTabs();
      this.loadConfig();
    },
    destroy() {
      this.timerStop();
    }
  },
  watch : {
    $route(to, from) {
      if(window.kShare){
        kShare.make({
          title: to.meta.title,
          url: location.href
        })
      }
    }
  },
  async created() {
    await this.init();
  },
  beforeDestroy() {
    this.destroy()
  }
})
